/**
 * Help §5.5 — Starting a project (`prekickoff/PreKickoffPanel.tsx`,
 * `prekickoff/AddInformationPanel.tsx`, `prekickoff/prekickoffModel.ts`).
 */
import { helpSectionMeta } from '../help-sections.js';
import { Btn, Bullets, HelpSectionCard, Li, P, Screen, Shot, SubHead } from '../HelpPrimitives.js';

export function Start(): React.JSX.Element {
  return (
    <HelpSectionCard meta={helpSectionMeta('start')}>
      <SubHead>Two ways to create a project</SubHead>
      <Bullets>
        <Li>
          From a client email — open it in the <Screen>Inbox</Screen> and click{' '}
          <Btn>Create Project</Btn>.
        </Li>
        <Li>
          By hand — click <Btn>New Project</Btn> on the project list.
        </Li>
      </Bullets>

      <SubHead>Inside the Pre-Kickoff stage</SubHead>
      <Shot
        slug="prekickoff"
        caption="The Pre-Kickoff panel — Add Information on one side, the AI Project Overview on the other."
      />
      <Bullets>
        <Li>
          The <Btn>Add Information</Btn> panel holds context text, file uploads, links and the
          Position Type together — there are no separate tabs for text and files any more.
        </Li>
        <Li>
          <Btn>Save Information</Btn> stores what you’ve entered.
        </Li>
        <Li>
          The analysis button changes its label with the state: <Btn>AI Analysis</Btn> the first
          time, <Btn>Re-Run Analysis</Btn> once it has run, and <Btn>Save &amp; Run Analysis</Btn>{' '}
          when you have unsaved changes.
        </Li>
      </Bullets>

      <SubHead>Choosing the next step</SubHead>
      <P>
        Three options are offered, and the recommended one carries an <Btn>AI Recommended</Btn>{' '}
        badge:
      </P>
      <Bullets>
        <Li>
          <Btn>Kick-off Meeting</Btn> — schedule a meeting right away.
        </Li>
        <Li>
          <Btn>Request Details</Btn> — request the JD and brief in writing.
        </Li>
        <Li>
          <Btn>Hybrid (Meeting + Questions)</Btn> — schedule a meeting and send a list of questions.
        </Li>
      </Bullets>
    </HelpSectionCard>
  );
}
